/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ContactLieuDoublonGridDto } from './ContactLieuDoublonGridDto';
import {
    ContactLieuDoublonGridDtoFromJSON,
    ContactLieuDoublonGridDtoFromJSONTyped,
    ContactLieuDoublonGridDtoToJSON,
} from './ContactLieuDoublonGridDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface ContactLieuDoublonGridDtoPaginatedResults
 */
export interface ContactLieuDoublonGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof ContactLieuDoublonGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<ContactLieuDoublonGridDto>}
     * @memberof ContactLieuDoublonGridDtoPaginatedResults
     */
    results?: Array<ContactLieuDoublonGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof ContactLieuDoublonGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the ContactLieuDoublonGridDtoPaginatedResults interface.
 */
export function instanceOfContactLieuDoublonGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ContactLieuDoublonGridDtoPaginatedResultsFromJSON(json: any): ContactLieuDoublonGridDtoPaginatedResults {
    return ContactLieuDoublonGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function ContactLieuDoublonGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): ContactLieuDoublonGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(ContactLieuDoublonGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function ContactLieuDoublonGridDtoPaginatedResultsToJSON(value?: ContactLieuDoublonGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(ContactLieuDoublonGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

